module.exports = __webpack_public_path__ + "img/42ee921bd490be84367e6c105e1bfed9.017b1bfb.jpg";